/**
 * Passaggio di stato fra due pagine del BO quando una scheda ne apre un'altra e poi ci
 * torna: es. Nuovo acquisto -> Nuovo fornitore -> di nuovo Nuovo acquisto, con la bozza
 * intatta e il fornitore appena creato gia' scelto.
 *
 * Si tiene in memoria e in sessionStorage, cosi' regge anche un refresh della pagina in
 * mezzo. Ogni valore si legge una volta sola (`take`), poi sparisce: una bozza vecchia non
 * puo' ricomparire in un inserimento nuovo.
 */
const KEY = 'pageHandoff:';
const memory = {};

export function putHandoff(name, value) {
	memory[name] = value;
	try {
		sessionStorage.setItem(KEY + name, JSON.stringify(value));
	} catch (e) {
		// niente sessionStorage (o bozza troppo grande): basta la memoria
	}
}

/** Legge senza consumare: la pagina figlia guarda la bozza che la pagina di partenza ritrovera'. */
export function peekHandoff(name) {
	if (memory[name] !== undefined) return memory[name];
	try {
		const stored = sessionStorage.getItem(KEY + name);
		return stored ? JSON.parse(stored) : null;
	} catch (e) {
		return null;
	}
}

export function takeHandoff(name) {
	let value = memory[name];
	delete memory[name];
	try {
		const stored = sessionStorage.getItem(KEY + name);
		sessionStorage.removeItem(KEY + name);
		if (value === undefined && stored) value = JSON.parse(stored);
	} catch (e) {
		// niente sessionStorage: resta quello che c'era in memoria
	}
	return value === undefined ? null : value;
}

/**
 * Le pagine che possono aprire una scheda e farsi riportare indietro. La scheda aperta
 * riceve solo la chiave in `?from=`: niente percorsi liberi nell'URL, cosi' il ritorno
 * va sempre in un posto conosciuto e il titolo della freccia lo dice.
 */
export const RETURN_TARGETS = {
	'bought-new': { path: '/bought/new', label: 'Torna al nuovo acquisto' },
};

export function returnTarget(from) {
	return Object.prototype.hasOwnProperty.call(RETURN_TARGETS, from) ? RETURN_TARGETS[from] : null;
}
